module.exports = __webpack_public_path__ + "/images/cover-mujer-joven-embarazada-movil-resp.71360c5.jpg";